import { Injectable } from '@angular/core';
import { DataService } from 'src/app/data-service/data.service';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})

export class DashboardService {
  baseURL: any;
  constructor(private dataService: DataService) {
    this.baseURL = environment.apiBase;
  }

  login(param) {
    return this.dataService.postService(`/admin/Admin/login`, param);
  }
  // update admin profile
  updateAdminProfileAPICall(param) {
    return this.dataService.postService(`/admin/Admin/updateProfileAdmin`, param);
  }
  updateError(param) {
    return this.dataService.postService(`/admin/Error_code/edit_single_error_code`, param);
  }
  // Admin Profile Details
  getAdminProfile() {
    return this.dataService.getService(`/admin/Admin/getUserDetailsById`);
  }
  // WMS Profile Details
  getWmsProfile() {
    return this.dataService.getService(`/wms/Wms/getUserDetailsById`);
  }
  // Normal Profile Details
  getNormalProfile() {
    return this.dataService.getService(`/normal/Normal/getUserDetailsById`);
  }
  getZeProfile() {
    return this.dataService.getService(`/zedg/ZEDG/getUserDetailsById`);

  }
  adminChangePassword(param) {
    return this.dataService.postService('/admin/Admin/changePassword', param);
  }

  //normal change password
  normalChangePassword(param) {
    return this.dataService.postService('/normal/Normal/changePassword', param);
  }
  //wms change password
  wmsChangePassword(param) {
    return this.dataService.postService('/wms/Wms/changePassword', param);
  }
  zedgChangePassword(param) {
    return this.dataService.postService('/zedg/ZEDG/changePassword', param);
  }
  // EPC Profile Details
  getEpcProfile() {
    return this.dataService.getService(`/epc/Epc/getUserDetailsById`);
  }

  // update epc profile
  updateEpcProfileAPICall(param) {
    return this.dataService.postService(`/epc/Epc/updateProfileEpc`, param);
  }
  epcChangePassword(param) {
    return this.dataService.postService('/epc/Epc/changePassword', param);
  }
  // dashboard api of admin
  getAdminDashboardData() {
    return this.dataService.getService(`/admin/Admin/getDashboardData`);
  }
  // dashboard api of admin
  totalEnergyGeneratedAdmin() {
    return this.dataService.getService(`/admin/Admin/totalEnergyGeneratedAdmin`);
  }
  // dashboard api of epc
  getDashboardData() {
    return this.dataService.getService(`/epc/Epc/getDashboardData`);
  }
  // dashboard api of normal user
  getNormalUserDashboardData() {
    return this.dataService.getService(`/normal/Normal/getDashboardData`);
  }
  // dashboard api of wms user
  getWmsUserDashboardData() {
    return this.dataService.getService(`/wms/Wms/getDashboardData`);
  }
  // dashboard api of ZE user
  getZEUserDashboardData() {
    return this.dataService.getService(`/zedg/ZEDG/getDashboardData`);
  }
  // dashboard api of DG user
  getDGUserDashboardData() {
    return this.dataService.getService(`/zedg/ZEDG/getDashboardData`);
  }
  // System Details API of normal user
  getSystemDetailsData() {
    return this.dataService.getService(`/normal/Normal/getSystemDetails`);
  }

  getSystemDetailsZEDGData() {
    return this.dataService.getService(`/zedg/ZEDG/getSystemDetails`);
  }
  // System Details API of normal user
  getWmsSystemDetailsData() {
    return this.dataService.getService(`/wms/Wms/getSystemDetails`);
  }

  getDashboardDataInfo() {
    return this.dataService.getService(`/epc/Epc/getDeviceInfo`);
  }
  totalEnergyGeneratedEPC() {
    return this.dataService.getService(`/epc/Epc/totalEnergyGeneratedEPC`);
  }
  // add device by admin
  addDevice(param) {
    return this.dataService.postService('/admin/Device/addDevices', param);
  }
  // update cdevice
  updateDevice(param) {
    return this.dataService.postService('/admin/Device/updateDevice', param);
  }
  //edit device by id
  getInfoByDeviceId(param) {
    return this.dataService.postService('/admin/Device/getDeviceById', param);
  }

  getInfoByUserIdError(param) {
    return this.dataService.postService('/admin/Error_code/get_single_error_code', param);
  }
  getAllDevices(param) {
    return this.dataService.postService(`/admin/Device/getAllDevices`, param);
  }

  getThirdPartyUser(param) {
    return this.dataService.postService(`/admin/admin/getThirdPartyUser`, param);
  }
  getAllModelMakeId() {

    return this.dataService.getService(`/admin/Error_code/get_list_models`);
  }
  addErrorLog(param) {
    return this.dataService.postService(`/admin/Error_code/add_error_code`, param);
  }
  getAllErrorCode(param) {
    return this.dataService.postService(`/admin/Error_code/get_list_error_code`, param);
  }
  //add wms user
  addWms(param) {
    return this.dataService.postService('/epc/Wms/createWmsUser', param);
  }
  //add wms user
  AdminaddWms(param) {
    return this.dataService.postService('/admin/Wms/createWmsUser', param);
  }
  //add dg user in epc ortal
  addEpcDg(param) {
    return this.dataService.postService('/epc/DG/createDGUser', param);
  }

  //add dg user
  AdminaddDG(param) {
    return this.dataService.postService('/admin/DG/createDGUser', param);
  }
  //add ze user
  AdminaddZE(param) {
    return this.dataService.postService('/admin/ZE/createZEUser', param);
  }
  //get epc user devices
  getAllEpcUserDevice() {
    return this.dataService.getService('/epc/Wms/getAllDeviceForUser');
  }
  //updtae wms user
  updateWmsUser(param) {
    return this.dataService.postService('/epc/Wms/updateWmsUser', param);
  }

  //  //updtae epc -> dg  user
  //   updateDgUser(param){
  //     return this.dataService.postService('/epc/Wms/updateWmsUser', param);
  //   }

  //updtae wms user
  adminUpdateWmsUser(param) {
    return this.dataService.postService('/admin/Wms/updateWmsUser', param);
  }
  //updtae wms user
  adminUpdateDgUser(param) {
    return this.dataService.postService('/admin/DG/updateDGUser', param);
  }

  // add normal user
  addNormalUser(param) {
    return this.dataService.postService('/epc/Normal/createNormalUser', param);
  }
  // add normal user for admin
  addAdminNormalUser(param) {
    return this.dataService.postService('/admin/Normal/createNormalUser', param);
  }
  //updateNormalUser
  updateNormalUser(param) {
    return this.dataService.postService('/epc/Normal/updateNormalUser', param);
  }
  //updateNormalUser
  updateAdminNormalUser(param) {
    return this.dataService.postService('/admin/Normal/updateNormalUser', param);
  }
  //get info by id normal user
  getInfoByUserId(param) {
    return this.dataService.postService('/epc/Normal/getNormalUsersById', param);
  }
  //get info by id normal user for admin
  getNormalInfoByUserId(param) {
    return this.dataService.postService('/admin/Normal/getNormalUsersById', param);
  }
  //get info by id wms user
  getInfoByWmsUserId(param) {
    return this.dataService.postService('/epc/Wms/getWmsUsersById', param);
  }

  //get info by id epc dg user
  //  getInfoByEpcDgUserId(param){
  //   return this.dataService.postService('/epc/Wms/getWmsUsersById', param);
  // }
  //get info by id wms user
  getAdminInfoByWmsUserId(param) {
    return this.dataService.postService('/admin/Wms/getWmsUsersById', param);
  }
  //get info by admin dg user
  getAdminInfoByDgUserId(param) {
    return this.dataService.postService('/admin/DG/getDGUsersById', param);
  }

  //get add device in epc
  getAllUserDevice() {
    return this.dataService.getService(`/epc/Device/getAllDeviceForUser`);
  }
  //get all devices for admin
  getAllMasterDevices(param) {
    return this.dataService.postService(`/admin/Device/getAllDeviceForUser`, param);
  }
  //get all Epcnormal user list
  getNormalUserList(param) {
    return this.dataService.postService(`/epc/Normal/getAllNormalUsers`, param);
  }
  
   getAllUserList(param) {
    return this.dataService.postService(`/epc/Epc/getAllUsers`, param);
  }

  //get allAdmin Normaluser
  getAllAdminNormalUserList(param) {
    return this.dataService.postService(`/admin/Normal/getAllNormalUsers`, param);
  }
  // get allAdmin wms_user list
  getAllAdminWmsUserList(param) {
    return this.dataService.postService(`/admin/Wms/getAllWmsUsers`, param);
  }
  //get allEpc wms user list
  getWmsUserList(param) {
    return this.dataService.postService(`/epc/Wms/getAllWmsUsers`, param);
  }
  //get info to edit
  getInfoByEpcId(param) {
    return this.dataService.postService(`/admin/Epc/getEpcById`, param);
  }
  // add allAdminEpc user
  addEpcUser(param) {
    return this.dataService.postService('/admin/Epc/createEpcUser', param);
  }
  // get allAdminEpc user
  getAllEpcUser(param) {
    return this.dataService.postService(`/admin/Epc/getAllEpcUsers`, param);
  }
  // get all Admin DG user
  getAllDGEpcUser(param) {
    return this.dataService.postService(`/admin/Epc/getAllEpcUsers`, param);
  }
  // get allAdminEpc user
  deleteDeviceBuId(param) {
    return this.dataService.postService(`/admin/Device/deleteDeviceById`, param);
  }
  deleteErrorById(param) {
    return this.dataService.postService(`/admin/Error_code/remove_error_code`, param);
  }
  //update epc user
  updateEpcUser(param) {
    return this.dataService.postService(`/admin/Epc/updateEpcUser`, param);
  }
  // Add multiple Device And Sub Device
  addMultipleDevice(param) {
    return this.dataService.postService(`/epc/Normal/addDeviceForNormalUser`, param);
  }
  // getAll Epc NormlUser
  getEpcNormalUser() {
    return this.dataService.getService(`/epc/Epc/getAllWmsAndNormalUsers`);
  }
  getAdminNormalAndWmsUser(param) {
    return this.dataService.postService(`/admin/Admin/getAllWmsAndNormalUsers`, param);
  }
  //get normal user devices by its id for epc
  getNormalUserDevicesById(param) {
    return this.dataService.postService(`/epc/Normal/getDeviceForNormalUser`, param);
  }
  //get normal user devices by its id for admin
  getAdminNormalUserDevicesById(param) {
    return this.dataService.postService(`/admin/Normal/getDeviceForNormalUser`, param);
  }
  //get Cleared Alarms for epc user
  getClearedAlarms(param) {
    return this.dataService.postService(`/epc/Alarms/getClearedEpcAlarms`, param);
  }
  getAdminClearedAlarms(param) {
    return this.dataService.postService(`/admin/Alarms/getClearedAdminAlarms`, param);
  }
  //get Uncleared Alarms for epc user
  getUnclearedAlarms(param) {
    return this.dataService.postService(`/epc/Alarms/getUnclearedEpcAlarms`, param);
  }
  //get Uncleared Alarms for admin user
  getAdminUnclearedAlarms(param) {
    return this.dataService.postService(`/admin/Alarms/getUnclearedAdminAlarms`, param);
  }
  //echeck epc User
  checkUser(param) {
    return this.dataService.postService(`/admin/Admin/checkUserName`, param);
  }
  //wms device list
  getWmsUserDevicesById(param) {
    return this.dataService.postService(`/epc/Wms/getDeviceForWmsUser`, param);
  }
  //wms device list for admin
  getAdminWmsUserDevicesById(param) {
    return this.dataService.postService(`/admin/Wms/getDeviceForWmsUser`, param);
  }
  //wms device list for admin
  getAdminDgUserDevicesById(param) {
    return this.dataService.postService(`/admin/DG/getDeviceForDGUser`, param);
  }
  //get epc user devices
  getAllWmsSensorList() {
    return this.dataService.getService('/epc/Device/getSensorList');
  }
  getAllEpcSensorList() {
    return this.dataService.getService('/epc/Device/getSensorList');
  }
  //get epc user devices
  getAdminAllWmsSensorList() {
    return this.dataService.getService('/admin/Device/getSensorList');
  }
  getAdminAllDGSensorList() {
    return this.dataService.getService('/admin/Device/getDGList');
  }
  // update multiple device
  updateDeviceById(param) {
    return this.dataService.postService(`/epc/Normal/updateDeviceForNormalUser`, param);
  }
  // update multiple device
  updateAdminDeviceById(param) {
    return this.dataService.postService(`/admin/Normal/updateDeviceForNormalUser`, param);
  }
  // get Device Data of epc
  getDeviceDataOfUser(param) {
    return this.dataService.postService(`/epc/Epc/getDeviceDataOfUsers`, param);
  }
  // get Device Data of epc
  getDeviceDataOfZEUser(param) {
    return this.dataService.postService(`/epc/ZE/getDeviceForZEUser`, param);
  }


  getDeviceDataOfDGUser(param) {
    return this.dataService.postService(`/epc/ZE/getDeviceForZEUser`, param);
  }
  // get Device Data of Admin
  getDeviceDataOfAdminUser(param) {
    return this.dataService.postService(`/admin/Admin/getDeviceDataOfUsers`, param);
  }
  getDeviceDataOfAdminZEUser(param) {
    return this.dataService.postService(`/admin/ZE/getAllZEUsers`, param);
  }


  getDeviceDataOfAdminDGUser(param) {
    return this.dataService.postService(`/admin/DG/getAllDGUsers`, param);
  }
  // get all Subdevice list
  getAllSubDevice() {
    return this.dataService.getService(`/epc/Device/getAllSubDevices`);
  }
  getAllSubDeviceByAdmin() {
    return this.dataService.getService(`/admin/Device/getAllSubDevices`);
  }
  // get All Model by Sub Device Id
  getAllModelBySubDevicesId(param) {
    return this.dataService.postService(`/epc/Device/getAllModelBySubDevicesId`, param);
  }
  //change password normal user epc
  changePasswordByUserId(param) {
    return this.dataService.postService(`/epc/Epc/resetPasswordOfUser`, param);
  }
  //change password  users for admin
  changePasswordNormalAndWmsByUserId(param) {
    return this.dataService.postService(`/admin/Admin/resetPasswordOfUser`, param);
  }
  //change password user admin
  changePasswordByUserIdAdmin(param) {
    return this.dataService.postService(`/admin/Admin/resetPasswordOfEpc`, param);
  }
  // day graph for normal
  public dashboardNormalUserEnergyDayGraph(param) {
    return this.dataService.postService(`/graph/Graph/cumulative_today_graph`, param);
  }
  // day graph for ze
  dashboardZEUserEnergyDayGraph(param) {
    return this.dataService.postService(`/graph/Graph/cumulative_today_graph_ZEDG`, param);
  }

  // day graph for DG  R
  dashboardUserEnergyDayGraphDG(param) {
    return this.dataService.postService(`/graph/Graph/cumulative_today_graph_ZEDG_DG`, param);
  }

  // day graph for dg
  dashboardDGUserEnergyDayGraph(param) {
    return this.dataService.postService(`/graph/Graph/cumulative_today_graph`, param);
  }
  // month graph for norma /wms
  public dashboardNormalUserEnergyMonthGraph(param) {
    return this.dataService.postService(`/graph/Graph/cumulative_month_graph `, param);
  }

  dashboardZEUserEnergyMonthGraph(param) {
    return this.dataService.postService(`/graph/Graph/cumulative_month_graph `, param);
  }

  // year graph for normal
  public dashboardNormalUserEnergyYearGraph(param) {
    return this.dataService.postService(`/graph/Graph/cumulative_year_graph`, param);
  }

  // year graph for ze
  public dashboardZEUserEnergyYearGraph(param) {
    return this.dataService.postService(`/graph/Graph/cumulative_year_graph`, param);
  }


  // life_time graph for normal
  public dashboardNormalUserEnergyLifeTimeGraph(param) {
    return this.dataService.postService(`/graph/Graph/cumulative_life_time_graph`, param);
  }
  // year graph wms.......replace this api with new api
  public dashboardWmsUserEnergyYearGraph(param) {
    return this.dataService.postService(`/graph/Graph/cumulative_year_graph`, param);
  }

  // month graph wms.......replace this api with new api
  public dashboardWmsUserEnergyMonthGraph(param) {
    return this.dataService.postService(`/graph/Graph/cumulative_month_graph `, param);
  }
  dashboardWmsUserAmbientAndIrraditionDayGraph(param) {
    return this.dataService.postService(`/graph/Graph/dashboard_sensor_parameter_graph`, param);
  }

  // inverter Details for wms user dashboard
  getWmsInverterDetails() {
    return this.dataService.getService(`/wms/Wms/getInverterDetails`);
  }
  public getLoadGrid(param) {
    return this.dataService.postService(`/graph/Graph/get_dashboard_load_grid_data`, param);
  }
  // get inverter list for normal user report change
  public getInverterList() {
    return this.dataService.getService(`/normal/Report/getInverrterList`);
  }
  // get inverter list for normal user report change
  public getInverterListZE() {
    return this.dataService.getService(`/zedg/Report/getInverrterList`);
  }


  // get inverter Detaisl for wms user
  public getWmsInverterList() {
    return this.dataService.getService(`/wms/Report/getInverrterList`);
  }

  getZeDgInverterList() {
    return this.dataService.getService(`/zedg/Report/getInverrterList`);
  }

  // get inverter Detaisl for wms user
  public getWmsMeterList() {
    return this.dataService.getService(`/wms/Report/getMeterList`);
  }

  public getZEMeterList() {
    return this.dataService.getService(`/zedg/Report/getMeterList`);
  }

  // get inverter list for normal user report
  public getParameterList() {
    return this.dataService.getService(`/normal/Report/getParameterList`);
  }
  // device status for normal user dashboard old
  public getDeviceStatus() {
    return this.dataService.getService(`/normal/Normal/getDeviceStatus`);
  }

  // device status for normal user dashboard new
  public getDeviceErrorStatus(param) {
    return this.dataService.postService(`/normal/Alarms/getDeviceStatus`, param);
  }
  public getInverterErrorStatus(param) {
    return this.dataService.postService(`/normal/Alarms/getDeviceStatus`, param);
  }

  // device status for wms user dashboard
  getWmsDeviceStatus() {
    return this.dataService.getService(`/wms/Wms/getDeviceStatus`);
  }
  // inverter Details for normal user dashboard
  public getInverterDetails() {
    return this.dataService.getService(`/normal/Normal/getInverterDetails`);
  }
  // Inverter status for normal user dashboard old
  public getInverterStatus() {
    return this.dataService.getService(`/normal/Normal/getInverterStatus`);
  }

  // Inverter status for normal user dashboard new
  public getInverterStatusNormal(param) {
    return this.dataService.postService(`/normal/Alarms/getDeviceStatus`, param);
  }
  public getMeterStatus() {
    return this.dataService.getService(`/zedg/ZEDG/getMeterStatus`);
  }

  // R
  public getDgStatus() {
    return this.dataService.getService(`/zedg/ZEDG/getDgStatus`);
  }

  public getGridStatus() {
    return this.dataService.getService(`/zedg/ZEDG/getGridStatus`);
  }
  public getDeviceNewStatus() {
    return this.dataService.getService(`/zedg/ZEDG/getDGDeviceStatus`);
  }

  // inverter Details for ZE user dashboard
  public getZEInverterDetails() {
    return this.dataService.getService(`/zedg/ZEDG/getInverterDetails`);
  }
  // Inverter status for ZE user dashboard
  public getZEInverterStatus() {
    return this.dataService.getService(`/zedg/ZEDG/getInverterStatus`);
  }
  // inverter Details for DG user dashboard
  public getDGInverterDetails() {
    return this.dataService.getService(`/zedg/ZEDG/getInverterDetails`);
  }
  // Inverter status for DG user dashboard
  public getDGInverterStatus() {
    return this.dataService.getService(`/zedg/ZEDG/getInverterStatus`);
  }
  // Inverter status for wms user dashboard
  getWmsInverterStatus() {
    return this.dataService.getService(`/wms/Wms/getInverterStatus`);
  }
  // day graph for normal user in inverter Details
  public normalUserEnergyDayGraph(param) {
    return this.dataService.postService(`/graph/Graph/inverter_today_graph`, param);
  }

  // day graph for normal user in inverter Details
  public zeUserEnergyDayGraph(param) {
    return this.dataService.postService(`/graph/Graph/inverter_today_graph`, param);
  }


  // graph api for wms
  wmsUserEnergyDayGraphAllInv(param) {
    return this.dataService.postService(`/wms/Report/inverterwiseToday`, param)
  }
  wmsUserEnergyMonthGraphInv(param) {
    return this.dataService.postService(`/wms/Report/inverterWiseMonth`, param)
  }

  wmsUserEnergyYearGraphInv(param) {
    return this.dataService.postService(`/wms/Report/inverterwiseYear`, param)
  }
  wmsUserEnergyLifeTimeGraphInv(param) {
    return this.dataService.postService(`/wms/Report/inverterwiseLifeTime`, param)
  }
  // graph api for normal
  normalUserEnergyDayGraphInv(param) {
    return this.dataService.postService(`/normal/Report/inverterwiseToday`, param)
  }
  normalUserEnergyMonthGraphInv(param) {
    return this.dataService.postService(`/normal/Report/inverterWiseMonth`, param)
  }

  normalUserEnergyYearGraphInv(param) {
    return this.dataService.postService(`/normal/Report/inverterwiseYear`, param)
  }

  normalUserEnergyLifeTimeGraphInv(param) {
    return this.dataService.postService(`/normal/Report/inverterwiseLifeTime`, param)
  }

  //change following api whn change
  ZEUserEnergyMonthGraphInv(param) {
    return this.dataService.postService(`/zedg/Report/inverterWiseMonth`, param)
  }
  //change following api whn change
  ZEUserEnergyYearGraphInv(param) {
    return this.dataService.postService(`/zedg/Report/inverterwiseYear`, param)
  }

  ZEUserEnergyLifeTimeGraphInv(param) {
    return this.dataService.postService(`/zedg/Report/inverterwiseLifeTime`, param)
  }

  // month graph for normal user in inverter Details
  public normalUserEnergyMonthGraph(param) {
    return this.dataService.postService(`/graph/Graph/inverter_month_graph`, param);
  }


  public ZEUserEnergyMonthGraph(param) {
    return this.dataService.postService(`/graph/Graph/inverter_month_graph`, param);
  }
  // Year graph for normal user in inverter Details
  public normalUserEnergyYearGraph(param) {
    return this.dataService.postService(`/graph/Graph/inverter_year_graph`, param);
  }
  // Year graph for ze user in inverter Details
  ZEUserEnergyYearGraph(param) {
    return this.dataService.postService(`/graph/Graph/inverter_year_graph`, param);
  }

  public normalUserEnergyLifeTimeGraph(param) {
    return this.dataService.postService(`/graph/Graph/inverter_lifetime_graph`, param);
  }
  public ZEUserEnergyLifeTimeGraph(param) {
    return this.dataService.postService(`/graph/Graph/inverter_lifetime_graph`, param);
  }

  // Parameter and Value list for normal user inverter details
  public getParameterAndValueList(param) {
    return this.dataService.postService(`/normal/Normal/getParameterAndValueList`, param);
  }
  // Parameter and Value list for normal user inverter details
  public getParameterAndValueListZE(param) {
    return this.dataService.postService(`/zedg/ZEDG/getParameterAndValueList`, param);
  }

  // Parameter and Value list for normal user inverter details
  public getMeterList(param) {
    return this.dataService.postService(`/normal/Report/getMeterList`, param);
  }
  // Parameter and Value list for normal user inverter details Report page
  public getParamNoAndParamNameList(param) {
    return this.dataService.postService(`/normal/Normal/getParamNoAndParamNameList`, param);
  }
  // Parameter and Value list for normal user inverter details Report page
  public getParamNoAndParamNameListZE(param) {
    return this.dataService.postService(`/zedg/ZEDG/getParamNoAndParamNameList`, param);
  }


  // Parameter and Value list for Wms user inverter details Report page getParameterAndValueList
  public getParamNoAndParamNameListOfWms(param) {
    return this.dataService.postService(`/wms/Wms/getParamNoAndParamNameList`, param);
  }
  // Parameter and Value list for wms user inverter details
  public getWmsParameterAndValueList(param) {
    return this.dataService.postService(`/wms/Wms/getParameterAndValueList`, param);
  }
  //get MpptData for Normal User
  public getmpptData(param) {
    return this.dataService.postService(`/normal/Mppt/getMpptData`, param);
  }
  //get MpptData for wms User
  public getWmsmpptData(param) {
    return this.dataService.postService(`/wms/Mppt/getMpptData`, param);
  }
  //get MpptData for ZE User
  getZeDgmpptData(param) {
    return this.dataService.postService(`/zedg/Mppt/getMpptData`, param);
  }

  //get MpptData for Normal User
  public getStringData() {
    return this.dataService.getService(`/normal/Mppt/getStringData`);
  }
  //get Clear Alarms for Normal User
  getNormalUserClearedAlarms(param) {
    return this.dataService.postService(`/normal/Alarms/getClearedNormalAlarms`, param);
  }

  //get Clear Alarms for ZE User
  getZEUserClearedAlarms(param) {
    return this.dataService.postService(`/normal/Alarms/getClearedNormalAlarms`, param);
  }
  // get all menus for slave Admin
  getAllMenu(param) {
    return this.dataService.postService(`/admin/Slaveadmin/getAllMasterAdminMenus`, param);
  }
  getSlaveAdminById(param) {
    return this.dataService.postService(`/admin/Slaveadmin/getSlaveAdminById`, param);
  }
  // create slave  Admin  /admin/Slaveadmin/updateSlaveAdmin
  addSlaveAdmin(param) {
    return this.dataService.postService(`/admin/Slaveadmin/createSlaveAdmin`, param);
  }
  updateSlaveAdmin(param) {
    return this.dataService.postService(`/admin/Slaveadmin/updateSlaveAdmin`, param);
  }
  // get all slave admin
  getAllSlaveAdmins(param) {
    return this.dataService.postService(`/admin/Slaveadmin/getAllSlaveAdmins`, param);
  }
  deleteSlaveAdmins(param) {
    return this.dataService.postService(`/admin/Slaveadmin/deleteSlaveAdminById`, param);
  }
  //get UnClear Alarms for Normal User
  getNormalUserUnClearedAlarms(param) {
    return this.dataService.postService(`/normal/Alarms/getUnclearedNormalAlarms`, param);
  }
  //get UnClear Alarms for ze User
  getZEUserUnClearedAlarms(param) {
    return this.dataService.postService(`/normal/Alarms/getUnclearedNormalAlarms`, param);
  }


  // get Inverter Details By Id for Normal User inverter Details
  getInverterDetailsById(param) {
    return this.dataService.postService(`/normal/Report/getListOfInverter`, param);
  }

  // get Inverter Details By Id for ze User inverter Details
  getInverterDetailsByIdZE(param) {
    return this.dataService.postService(`/zedg/ZEDG/getListOfInverter`, param);
  }
  // get Inverter Details By Id for wms User inverter Details
  getWmsInverterDetailsById(param) {
    return this.dataService.postService(`/wms/Wms/getListOfInverter`, param);
  }
  // Update and Add Device with Sensor for wms User
  updateDeviceForWmsUser(param) {
    return this.dataService.postService(`/epc/Wms/updateDeviceForWmsUser`, param);
  }
  // Update and Add Device with Sensor for wms User
  updateDeviceForWmsUserByAdmin(param) {
    return this.dataService.postService(`/admin/Wms/updateDeviceForWmsUser`, param);
  }

  // Update and Add Device with Sensor for wms User
  updateDeviceForDgUserByAdmin(param) {
    return this.dataService.postService(`/admin/DG/updateDeviceForDGUser`, param);
  }

  updateDeviceForZeUserByAdmin(param) {
    return this.dataService.postService(`/admin/ZE/updateDeviceForZEUser`, param);
  }

  getExcelTodayFile() {
    return this.dataService.getService(`/csv/Csv/csvToday`);
  }
  //get excel file of year
  getExcelYearFile(param) {
    return this.dataService.postService(`/csv/Csv/csvYear`, param);
  }
  getReportGraph(param) {
    return this.dataService.postService(`/normal/Report/loadDayEnergyDownload`, param);
  }


  getReportGraphZE(param) {
    return this.dataService.postService(`/normal/Report/loadDayEnergyDownload`, param);
  }
  //get excel file of month
  getExcelMonthFile(param) {
    return this.dataService.postService(`/csv/Csv/csvMonth`, param);
  }
  // enable disable admin device status
  enableDisableDeviceStatusById(param) {
    return this.dataService.postService(`/admin/Device/enableDisableDeviceById`, param);
  }
  // enable disable epc status
  enableDisableEpcStatusById(param) {
    return this.dataService.postService(`/admin/Epc/enableDisableEPCUserById`, param);
  }
  // Sensor Data page
  sensorDataPage(param) {
    return this.dataService.postService(`/graph/Graph/loadWmsSensorData`, param);
  }
  // Sensor Data page
  singalSensorData(param) {
    return this.dataService.postService(`/graph/Graph/loadWmsSensorGraphData`, param);
  }
  // delete wms user by admin
  deleteWmsUserByAdmin(param) {
    return this.dataService.postService(`/admin/Wms/deleteWMSUserById`, param);
  }
  // delete Normal user by admin
  deleteNormalUserByAdmin(param) {
    return this.dataService.postService(`/admin/Normal/deleteNormalUserById`, param);
  }
  // delete ZE user by admin
  deleteZEUserByAdmin(param) {
    return this.dataService.postService(`/admin/ZE/deleteZEUserById`, param);
  }
  // delete wms user by epc
  deleteWmsUserByEpc(param) {
    return this.dataService.postService(`/epc/Wms/deleteWMSUserById`, param);
  }
  // delete wms user by epc
  deleteEpcUserByEpc(param) {
    return this.dataService.postService(`/admin/Epc/deleteEPCUserById`, param);
  }
  // delete wms user by epc
  deleteNormalUserByEpc(param) {
    return this.dataService.postService(`/epc/Normal/deleteNormalUserById`, param);
  }
  addBlog(param) {
    return this.dataService.postService(`/admin/Blognotification/createBlog`, param);
  }
  getAllBlog(param) {
    return this.dataService.postService(`/admin/Blognotification/getAllBlogs`, param);
  }
  // delete blog
  deleteBlogById(param) {
    return this.dataService.postService(`/admin/Blognotification/deleteBlogById`, param);
  }
  // delete notification
  deleteNotificationById(param) {
    return this.dataService.postService(`/admin/Blognotification/deleteNotificationById`, param);
  }
  add_notifiction(param) {
    return this.dataService.postService(`/admin/Blognotification/createNotification`, param);
  }
  getAllnotifiction(param) {
    return this.dataService.postService(`/admin/Blognotification/getAllNotifications`, param);
  }
  // renew date subscription normal user By admin
  adminNormalUserSubscription(param) {
    return this.dataService.postService(`/admin/Normal/renewNormalUserSubscriptionById`, param);
  }
  // renew date subscription wms user By admin
  adminWmsUserSubscription(param) {
    return this.dataService.postService(`/admin/Wms/renewWMSUserSubscriptionById`, param);
  }
  // renew date subscription normal user By epc
  epcNormalUserSubscription(param) {
    return this.dataService.postService(`/epc/Normal/renewNormalUserSubscriptionById`, param);
  }

  // renew date subscription dg user By admin
  adminDgUserSubscription(param) {
    return this.dataService.postService(`/admin/DG/renewDGUserSubscriptionById`, param);
  }


  // renew date subscription wms user By epc
  epcWmsUserSubscription(param) {
    return this.dataService.postService(`/epc/Wms/renewWMSUserSubscriptionById`, param);
  }
  loginViewPortal(param) {
    return this.dataService.postService(`/admin/Admin/loginViewPortal`, param);
  }
  loginViewPortalEpc(param) {
    return this.dataService.postService(`/epc/Epc/loginViewPortal`, param);
  }

  downloadNormalTodaysPdf(param) {
    return this.dataService.postService(`/normal/Report/pdfToday`, param);
  }
  downloadZESolarTodaysPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfToday`, param);
  }
// Report
  downloadZETodaysPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfTodayGrid`, param);
  }
  downloadDGTodaysPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfTodayDG`, param);
  }
  downloadDGGridTodaysPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfTodayGrid`, param);
  }
  downloadDGLoadTodaysPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfTodayLoad`, param);
  }
  downloadDGPlantTodaysPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfTodayPlant`, param);
  }
  downloadLoadTodaysPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfTodayLoad`, param);
  }
  downloadPlantTodaysPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfTodayPlant`, param);
  }

  downloadWmsTodaysPdf(param) {
    return this.dataService.postService(`/wms/Report/pdfToday`, param);
  }
  downloadNormalMonthPdf(param) {
    return this.dataService.postService(`/normal/Report/pdfMonth`, param);
  }

  downloadZEMonthPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfMonth`, param);
  }
  downloadWmsMonthPdf(param) {
    return this.dataService.postService(`/wms/Report/pdfMonth`, param);
  }
  downloadNormalYearPdf(param) {
    return this.dataService.postService(`/normal/Report/pdfYear`, param);
  }

  downloadZEYearPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfYear`, param);
  }

  downloadNormalYearPdfZE(param) {
    return this.dataService.postService(`/zedg/Report/pdfYear`, param);
  }
  downloadWmsYearPdf(param) {
    return this.dataService.postService(`/wms/Report/pdfYear`, param);
  }

  getCSVnormalUserReport(param1, param2) {
    return this.dataService.getService(`/normal/Report/csvToday?date=${param1}&user_id=${param2}`)
  }
  uploadFile(files): Promise<any> {

    const data = new FormData();
    if (files.__proto__.constructor.name === 'File') {
      data.append('files', files);
    } else {
      // tslint:disable-next-line:forin
      for (const i in files) {
        data.append('files', files[i]);
      }
    }

    return new Promise((resolve, reject) => {
      const xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(<any>JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      };
      xhr.open('POST', this.baseURL + '/admin/Epc/uploadImage', true);
      xhr.setRequestHeader('Authorization', localStorage.loginToken);
      // xhr.setRequestHeader();
      xhr.send(data);
    });
  }

  // upload notifiction file for Admin
  uploadPdfFile(files): Promise<any> {

    const data = new FormData();
    if (files.__proto__.constructor.name === 'File') {
      data.append('files', files);
    } else {
      // tslint:disable-next-line:forin
      for (const i in files) {
        data.append('files', files[i]);
      }
    }

    return new Promise((resolve, reject) => {
      const xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(<any>JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      };
      xhr.open('POST', this.baseURL + '/admin/Epc/uploadImage', true);
      xhr.setRequestHeader('Authorization', localStorage.loginToken);
      // xhr.setRequestHeader();
      xhr.send(data);
    });
  }
  //add admin inverter gain
  addInverterGain(param) {
    return this.dataService.postService('/admin/Makegain/addMakeId', param);
  }
  //update admin make id
  updateMakeId(param) {
    return this.dataService.postService(`/admin/Makegain/updateMakeId`, param);
  }
  //get info by make id
  getInfoByMakeId(param) {
    return this.dataService.postService('/admin/Makegain/getMakeById', param);
  }
  //get admin gain details
  getGainList(param) {
    return this.dataService.postService(`/admin/Makegain/getAllMakeIds`, param);
  }
  // get param gain detail by make id
  getParamGain(param) {
    return this.dataService.postService(`/admin/Makegain/getParamGainByMakeId`, param);
  }
  addParamGain(param) {
    return this.dataService.postService(`/admin/Makegain/addUpdateParamGain`, param);
  }
  //Get all meter type of admin energy meter
  getAllMeterTypeByAdmin() {
    return this.dataService.getService(`/admin/Device/getMeterList`);
  }
  //Get all meter type of admin energy meter
  getAllMeterTypeByEpcUser() {
    return this.dataService.getService(`/epc/Device/getMeterList`);
  }

  //get all ze users
  getAllAdminZEUserList(param) {
    return this.dataService.postService(`/admin/ZE/getAllZEUsers`, param);
  }
  //get all dg users
  getAllAdminDGUserList(param) {
    return this.dataService.postService(`/admin/DG/getAllDGUsers`, param);
  }
  //get meter list normal
  getNormalUsersMeterList() {
    return this.dataService.getService(`/normal/Report/getMeterList`);
  }
  //get meter list
  getWmsUsersMeterList() {
    return this.dataService.getService(`/wms/Report/getMeterList`);
  }
  getAllMeterTypeByEpc() {
    return this.dataService.getService(`/epc/Device/getMeterList`);
  }
  // device status for DG user dashboard
  public getDGDeviceStatus() {
    return this.dataService.getService(`/zedg/ZEDG/getDeviceStatus`);
  }
  // device status for ZE user dashboard
  public getZEDeviceStatus() {
    return this.dataService.getService(`/zedg/ZEDG/getDeviceStatus`);
  }
  //get all admin ze user
  getAllZeUser(param) {
    return this.dataService.postService(`/admin/ZE/getAllZEUsers`, param);
  }
  getAdminInfoByZeUserId(param) {
    return this.dataService.postService('/admin/ZE/getZEUsersById', param);
  }
  adminUpdateZeUser(param) {
    return this.dataService.postService('/admin/ZE/updateZEUser', param);
  }
  // renew date subscription normal user By admin
  adminZeUserSubscription(param) {
    return this.dataService.postService(`/admin/ZE/renewZEUserSubscriptionById`, param);
  }
  getDeviceForZeUser(param) {
    return this.dataService.postService(`/admin/ZE/getDeviceForZEUser`, param);
  }

  //get normal user devices by its id for admin
  getAdminZeUserDevicesById(param) {
    return this.dataService.postService(`/admin/ZE/getDeviceForZEUser`, param);
  }
  // epc ze user list
  getZeUserList(param) {
    return this.dataService.postService(`/epc/ZE/getAllZEUsers`, param);
  }
  addEpcZeUser(param) {
    return this.dataService.postService(`/epc/ZE/createZEUser`, param);
  }
  updateEpcZeUser(param) {
    return this.dataService.postService(`/epc/ZE/updateZEUser`, param);
  }
  getInfoByEpcZeUserId(param) {
    return this.dataService.postService(`/epc/ZE/getZEUsersById`, param);
  }
  getEpcZeUserDevicesById(param) {
    return this.dataService.postService(`/epc/ZE/getZEUsersById`, param);
  }
  getEpcZeDeviceUserDevicesById(param) {
    return this.dataService.postService(`/epc/ZE/getDeviceForZEUser`, param);
  }
  // Update and Add Device with Sensor for wms User
  updateDeviceForZEUser(param) {
    return this.dataService.postService(`/epc/ZE/updateDeviceForZEUser`, param);
  }
  deleteEpcZEUserByUserId(param) {
    return this.dataService.postService(`/epc/ZE/deleteZEUserById`, param);
  }
  epcZEUserSubscription(param) {
    return this.dataService.postService(`/epc/ZE/renewZEUserSubscriptionById`, param);
  }
  //ze device list
  getEpcZEUserDevicesById(param) {
    return this.dataService.postService(`/epc/ZE/getDeviceForZEUser`, param);
  }
  //epc dg user
  getDgUserList(param) {
    return this.dataService.postService(`/epc/DG/getAllDGUsers`, param);
  }
  //get info by id epc dg user
  getInfoByEpcDgUserId(param) {
    return this.dataService.postService('/epc/DG/getDGUsersById', param);
  }
  updateDgUser(param) {
    return this.dataService.postService('/epc/DG/updateDGUser', param);
  }
  epcDgUserSubscription(param) {
    return this.dataService.postService('/epc/DG/renewDGUserSubscriptionById', param);
  }
  deleteEpcDgUserByUserId(param) {
    return this.dataService.postService(`/epc/DG/deleteDGUserById`, param);
  }
  getEpcDgUserDevicesById(param) {
    return this.dataService.postService(`/epc/DG/getDeviceForDGUser`, param);
  }
  deleteDgUserByAdmin(param) {
    return this.dataService.postService(`/admin/DG/deleteDGUserById`, param);
  }
  updateDeviceForEpcDgUser(param) {
    return this.dataService.postService(`/epc/DG/updateDeviceForDGUser`, param);
  }

  getSubscriptionDateByUserId(param) {
    return this.dataService.postService('/admin/DG/getSubscriptionDateByUserId', param);
  }


  // month PDF

  downloadZEMonthGridPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfGridMonth`, param);
  }

  downloadZEMonthLoadPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfLoadMonth`, param);
  }

  downloadZEMonthPlantPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfPlantMonth`, param);
  }

  downloadDGMonthPlantPdf(param) {
    return this.dataService.postService(`/zedg/Report/pdfDGMonth`, param);
  }

  // year pdf


  downloadZEYearPdfZEGrid(param) {
    return this.dataService.postService(`/zedg/Report/pdfGridYear`, param);
  }

  downloadZEYearPdfZELoad(param) {
    return this.dataService.postService(`/zedg/Report/pdfLoadYear`, param);
  }

  downloadZEYearPdfZEPlant(param) {
    return this.dataService.postService(`/zedg/Report/pdfPlantYear`, param);
  }

  downloadZEYearPdfDGGrid(param) {
    return this.dataService.postService(`/zedg/Report/pdfGridYear`, param);
  }

  downloadZEYearPdfDGLoad(param) {
    return this.dataService.postService(`/zedg/Report/pdfLoadYear`, param);
  }

  downloadZEYearPdfDGPlant(param) {
    return this.dataService.postService(`/zedg/Report/pdfPlantYear`, param);
  }

  downloadZEYearPdfDg(param) {
    return this.dataService.postService(`/zedg/Report/pdfDGYear`, param);
  }

  // add device by admin
  getInverterListAdmin(param) {
    return this.dataService.postService('/admin/Admin/getInverterList', param);
  }

  getMpptDataAdmin(param) {
    return this.dataService.postService('/admin/Admin/getMpptData', param);
  }

  getStringMpptTableData(param) {
    return this.dataService.postService('/admin/Admin/getStringMpptTableData', param);
  } 

  addStringMpptTableData(param) {
    return this.dataService.postService('/admin/Admin/addStringMpptTableData', param);
  } 
  saveMpptAndStringNop(param) {
    return this.dataService.postService('/admin/Admin/saveMpptAndStringNop', param);
  }
  
  saveThirdParty(param) {
    return this.dataService.postService('/admin/Admin/saveThirdParty', param);
  }

  updateThirdParty(param) {
    return this.dataService.postService('/admin/Admin/updateThirdParty', param);
  }

  getAllUsers(param) {
    return this.dataService.postService('/admin/Admin/getTotalUsers', param);
  } 
  getUserInfoById(param) {
    return this.dataService.postService('/admin/Admin/getUserInfoById', param);
  } 

  deleteThirdParty(param) {
    return this.dataService.postService('/admin/Admin/deleteThirdParty', param);
  } 
  
}
